import React, { Component } from 'react';
import { Container, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, } from 'reactstrap';
import { PlayGameTab } from './PlayGameTab';
import { ManageGameTab } from './ManageGameTab';
import { SetupGameTab } from './SetupGameTab';
import { API, AUTH_ERROR } from '../../Logic/API';
import classnames from 'classnames';

const PlayTab = '1';
const ManageTab = '2';
const SetupTab = '3';

export class HostGame extends Component {

    constructor(props) {
        super(props);

        this.state = {
            activeTab: PlayTab,
            allGames: [],
            isLoadingGames: true
        };

        this.props.showHostingNav(false);

        this.loadGames();
    }

    refreshGames() {
        this.setState({ isLoadingGames: true });
        this.loadGames();
    }

    loadGames() {
        API.get('/gamehost/games')
            .then(resp => resp.json())
            .then(data => {
                this.setState({ allGames: data, isLoadingGames: false });
            })
            .catch(e => {
                console.log(e);
                if (e.message === AUTH_ERROR) {
                    this.props.history.push('/hosting');
                }
            });
    }

    selectTab(tab) {
        if (this.state.activeTab === tab) {
            return;
        }
        this.setState({ activeTab: tab });
    }

    render() {
        
        return (
            <Container>
                <Row>
                    
                    <Col>
                        <Nav tabs>
                            <NavItem>
                                <NavLink className={classnames({ active: this.state.activeTab === PlayTab })} onClick={() => this.selectTab(PlayTab)}>Spielen</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: this.state.activeTab === ManageTab })} onClick={() => this.selectTab(ManageTab)}>Verwalten</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: this.state.activeTab === SetupTab })} onClick={() => this.selectTab(SetupTab)}>Vorbereiten</NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId={PlayTab}>
                                <PlayGameTab games={this.state.allGames} isLoadingGames={this.state.isLoadingGames} />
                            </TabPane>
                            <TabPane tabId={ManageTab}>
                                <ManageGameTab games={this.state.allGames} isLoadingGames={this.state.isLoadingGames} refreshGames={() => this.refreshGames()}/>
                            </TabPane>
                            <TabPane tabId={SetupTab}>
                                <SetupGameTab games={this.state.allGames} isLoadingGames={this.state.isLoadingGames} />
                            </TabPane>
                        </TabContent>
                    </Col>
                    
                </Row>
            </Container>
            );
    }
}


// WEBPACK FOOTER //
// ./src/components/Admin/HostGame.jsx